import { withInstall } from '@zoryn/utils'
import ColorPicker from './src/color-picker.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZColorPicker: SFCWithInstall<typeof ColorPicker> =
  withInstall(ColorPicker)
export default ZColorPicker

export * from './src/color-picker'
